import { ConsultationStatus } from '@enums/consultation-status';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';

import { ConsultationRequestRequest } from './consultation-request-request';

export class BasicConsultationRequestRequest extends ConsultationRequestRequest {
  public constructor(
    orderId: string,
    treatmentType: ConsultationTreatmentTypes,
    firstName: string,
    lastName: string,
    dateOfBirth: string,
    email: string,
    consultation_status: ConsultationStatus = ConsultationStatus.Incomplete,
    pharmacy_id?: number,
    allergies?: string,
    health_info?: string,
  ) {
    super();

    this.order_id = orderId;
    this.treatment_type = treatmentType;
    this.first_name = firstName;
    this.last_name = lastName;
    this.date_of_birth = dateOfBirth;
    this.email = email;
    this.consultation_status = consultation_status;
    this.payment = { paymentType: 'free' };

    if (pharmacy_id) {
      this.pharmacy_id = pharmacy_id;
    }

    if (allergies) {
      this.allergies = allergies;
    }

    if (health_info) {
      this.health_info = health_info;
    }

    this.setAdditionalInfo();
  }
}
